import { apiClient } from "../client";

/** Backend enum: $table->enum('interested_in', [...]) */
export type ContactInterest = "general" | "astrology" | "shop" | "academy" | "other";

export interface ContactSubmitPayload {
  full_name: string;
  phone: string;
  email: string;
  interested_in: ContactInterest;
  /** YYYY-MM-DD — omit when the visitor leaves it blank. */
  date_of_birth?: string;
  /** HH:mm — omit when the visitor leaves it blank. */
  time_of_birth?: string;
  message: string;
  consent: boolean;
}

export interface ContactSubmitResponse {
  success?: boolean;
  message?: string;
  data?: unknown;
}

export const contact = {
  /** POST /contact — public contact-form submission. */
  submit: (payload: ContactSubmitPayload) =>
    apiClient.post<ContactSubmitResponse>("/contact", payload),
};
